import { useEffect, useState } from 'react';
import { useNavigation } from '@remix-run/react';
import styles from './TopLoadingBar.module.css';

export const TopLoadingBar = () => {
  const navigation = useNavigation();
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (navigation.state === 'loading') {
      setIsVisible(true);
      setProgress(0);
      
      const timer1 = setTimeout(() => setProgress(30), 100);
      const timer2 = setTimeout(() => setProgress(60), 300);
      const timer3 = setTimeout(() => setProgress(80), 600);
      
      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
        clearTimeout(timer3);
      };
    } else if (navigation.state === 'idle' && isVisible) {
      setProgress(100);
      
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 300);
      
      return () => clearTimeout(hideTimer);
    }
  }, [navigation.state, isVisible]);

  if (!isVisible) return null;

  return (
    <div className={styles.container}>
      <div 
        className={styles.bar}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
